import { useQuery } from '@tanstack/react-query';
import { verlofApi } from '../../../lib/verlofApi';

export const teamVerlofKeys = {
  all: ['leave-requests', 'team-verlof'] as const,
};

/**
 * Story 8.4 (besluit V39): het verlof van het eigen team, als LEESLIJST — de
 * weg waarlangs een leidinggevende het verloop van een aanvraag opent.
 *
 * Zelfde vorm als `useOnbevestigdeUren`: een lijst die door andermans handelen
 * verandert, dus een korte houdbaarheid, en geen `retry` — krijgt deze
 * gebruiker een 403, dan heeft opnieuw proberen geen zin.
 */
export function useTeamVerlof() {
  return useQuery({
    queryKey: teamVerlofKeys.all,
    queryFn: () => verlofApi.getTeamVerlof(),
    staleTime: 1000 * 30,
    retry: false,
  });
}
